import React from 'react';
import * as R from 'ramda';

import ThemeProvider from '@influitive/secret-garden/lib/theme-provider';

const customBrandingTheme = customBranding => (customBranding && customBranding.color_scheme) ? {
  colors: {
    primary: [ R.path(['color_scheme', 'primary_color'], customBranding) ],
    secondary: [ R.path(['color_scheme', 'secondary_color'], customBranding) ],
    bannerBackground: [ R.path(['color_scheme', 'banner_background'], customBranding) ]
  },
  fonts: {
    custom: customBranding.custom_font_enabled ? {
      fontName: customBranding.custom_font_name,
      fontUrl: customBranding.custom_font_url
    } : null
  }
} : {};

export default props =>
  <ThemeProvider theme={customBrandingTheme(props.customBranding)} {...props} />;
